module.exports = __webpack_public_path__ + "static/img/reporticon1.b56f4722.png";